import {GlobalService} from './global.service';
import {HttpClient} from '@angular/common/http';
import {
    ServicoVinculado,
    ParametroEntradaInstalacaoProduto,
    Parametro,
    ParametroConteudo,
    ItemConfiguracao,
    Operacao
} from './../model/catalogo';
import {Observable} from 'rxjs/Rx';
import {Injectable} from '@angular/core';
import {FTA, OrigemTransmissao, DestinoTransmissao, Evento, ResumoFTA} from '../model/catalogo';
import {OnInit} from '@angular/core/src/metadata/lifecycle_hooks';

@Injectable()
export class FtaService {

    resumoFTA: ResumoFTA;
    fta: FTA = null;
    eventoAtual: Evento = null;
    etapas: Array<any> = null;
    grupos: Array<any> = null;

    msgFtaSalvo: string = '';
    numFtaSalvo: number = 0;

    constructor(public http: HttpClient, public globalService: GlobalService) {
        // this.novoFluxo();
    }

    novoFluxo() {
        this.fta = new FTA();
        this.fta.eventos = new Array<Evento>();
        this.resumoFTA = new ResumoFTA();
        this.eventoAtual = null;
        this.etapas = [];
        this.grupos = [];
    }

    /* adiconar os serviços do FTA com a API*/

    public getServico(filtros: Array<any>): Observable<Array<ServicoVinculado>> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/servico/filtra';
        let data = JSON.stringify({'filtros': filtros});

        return this.http.post<Array<ServicoVinculado>>(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response['servicos']);
    }

    public atualizar(fta: FTA): Observable<FTA> {

        let url = this.globalService.getConfiguracao().api_catalogo + '/fta/' + fta.fta + '/' + fta.versao;

        return this.http.put<FTA>(url, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public buscarItemConfiguracaoProduto(filtros: Array<any>): Observable<ItemConfiguracao> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/itemConfiguracao/' + filtros;
        let data = JSON.stringify({'filtros': filtros});

        return this.http.get<ItemConfiguracao>(url, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public atualizaItemConfiguracaoProduto(nomeItemConfiguracao: string, tipoParametro: string, nomeParametro: string, parametro: ParametroEntradaInstalacaoProduto): any {
        let url = this.globalService.getConfiguracao().api_catalogo + '/itemConfiguracao/' + nomeItemConfiguracao + '/' + tipoParametro + '/' + 'nomeParametro';
        let data = JSON.stringify(parametro);

        return this.http.put(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public removeItemConfiguracaoProduto(nomeItemConfiguracao: string, tipoParametro: string, nomeParametro: string): any {
        let url = this.globalService.getConfiguracao().api_catalogo + '/itemConfiguracao/' + nomeItemConfiguracao + '/' + tipoParametro + '/' + nomeParametro;

        return this.http.delete(url, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public filtraOperacao(filtros: Array<any>): Observable<Array<Operacao>> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/operacao/filtra';
        let data = JSON.stringify({'filtros': filtros});

        return this.http.post<Array<Operacao>>(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}})
            .map(response => response['operacoes']);
    }

    public detalhaOperacao(codigo: number, versao: number): Observable<Operacao> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/operacao/' + codigo + '/' + versao;

        return this.http.get<Operacao>(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}});
    }

    public detalhadaFta(codigo: number, versao: number): Observable<FTA> {

        let url = this.globalService.getConfiguracao().api_catalogo + '/fta/' + codigo + '/' + versao;

        return this.http.get<FTA>(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}});
    }


    // // Retorna um novo Parâmetro de transmissão
    // public novoParametro(parmNome: string, conteudo: string): Parametro {
    //   let parmTransmissao: Parametro = new Parametro();
    //   let parmConteudo: ParametroConteudo = new ParametroConteudo();
    //   parmTransmissao.parmConteudo = new Array<ParametroConteudo>();
    //   parmTransmissao.parmNome = parmNome;
    //   parmConteudo.nrPosicao = 0;
    //   parmConteudo.conteudo = conteudo;
    //   parmTransmissao.parmConteudo.push(parmConteudo);
    //   return parmTransmissao;
    // }

    /* editarEventoAtual(evento: Evento) {
        this.eventoAtual = evento;
    } */

    /* buscarEvento(codigo: number): Evento {
        return this.fta.buscarEventoPorCodigo(codigo);
    } */

    /* montarEtapas() {
        if (this.fta == null) {
            return;
        }

        if (this.fta.eventos == null) {
            this.fta.eventos = new Array<Evento>();
        }

        this.etapas = [];

        this.fta.eventos.forEach(evento => {
            if (this.etapas.indexOf(evento.etapa) == -1) {
                this.etapas.push(evento.etapa);
            }
        });

        let qtdeEtapas = this.etapas != null ? this.etapas.length + 1 : 1;
        this.etapas = [];
        for (let index = 0; index < qtdeEtapas; index++) {
            let array = new Array<Evento>();
            this.fta.eventos.forEach(evento => {
                let ev = evento as Evento;
                if (ev.etapa == index + 1) {
                    array.push(evento);
                }
            });
            if (array.length == 0) {
                this.fta.eventos.forEach((evento, ind) => {
                    let ev = evento as Evento;
                    if (ev.etapa > index + 1) {
                        this.fta.eventos[ind].etapa = ev.etapa - 1;
                    }
                });
                qtdeEtapas--;
                index--;
            } else {
                this.etapas[index] = array;
            }
        }
    } */

    /* salvarEvento(evento: Evento) {
        if (this.fta == null) {
            this.novoFluxo();
        }
        if (this.fta.eventos == null) {
            this.fta.eventos = new Array<Evento>();
        }

        if (evento.evento == null) {
            evento.evento = Math.floor(Math.random() * 10000) + Date.now();
        }

        this.fta.salvarEvento(evento);
        this.editarEventoAtual(evento);
        this.montarEtapas();

    } */

    /* excluirEvento(evento: Evento) {
        this.fta.excluirEvento(evento);
        this.montarEtapas();
    } */

}



// WEBPACK FOOTER //
// ./src/service/fta.service.ts